export const previewPublishedGuide = {
  "title": "Your AI app works in preview. Check the published version.",
  "slug": "ai-app-preview-versus-published-version",
  "date": "2026-10-27",
  "description": "Compare your AI app’s preview and published version with the same browser flow. Identify each build, check shared data, and record the difference with Rill."
} as const;
